<template>
  <div class="welcomeBox">
    <van-swipe class="my-swipe" indicator-color="white" vertical :height="bodyHeight" :loop="false" ref="swiper" 
    :show-indicators='false'>
      <van-swipe-item>
        <div class="page">
          <div class="titleImg">
            <img src="../assets/welcome/yfzwzwrj.png" alt />
          </div>
          <div class="tagBox">
            <img src="../assets/welcome/advantage_ic0.png" alt />
          </div>
          <div class="content">
            <div class="contentBox">
              <div class="contentTitle">
                <img src="../assets/welcome/ic_title.png" alt />
              </div>
              <div class="contentList box_h" v-for="item in page1Content" :key="item.num">
                <div class="contentIcon">
                  <img :src="item.icon" alt />
                </div>
                <div class="contentInfo">
                  <div class="title box_h">
                    <span class="titleNum box_c" style="margin-right:3px">{{item.num}}</span>
                    <span class="titleTxt ">{{item.title}}</span>
                  </div>
                  <div class="contentDesc">{{item.desc}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="leftover" :style="{height:leftoverHeight+'px'}"></div>
          <div class="down" @click="swipeTo(1)">
            <img src="../assets/welcome/down.gif" alt="">
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="page">
          <div class="titleImg">
            <img src="../assets/welcome/zwrjmfm.png" alt />
          </div>
          <div class="tagBox">
            <img src="../assets/welcome/advantage_ic1.png" alt />
          </div>
          <div class="content" style="margin-top:30px">
            <div class="contentBox2">
              <div class="contentList" v-for="item in page2Content" :key="item.num">
                <div v-if="item.num%2==1" class="box_cqh a">
                  <div class="contentInfo">
                    <div class="title">
                      <span class="titleNum">{{item.num}}</span>
                    </div>
                    <div>
                      <div class="titleTxt">{{item.title}}</div>
                      <div class="contentDesc">{{item.desc}}</div>
                    </div>
                  </div>
                  <div class="contentIcon">
                    <img :src="item.icon" alt />
                  </div>
                </div>
                <div v-else class="box_cqh b">
                  <div class="contentIcon">
                    <img :src="item.icon" alt />
                  </div>
                  <div class="contentInfo">
                    <div class="title">
                      <span class="titleNum">{{item.num}}</span>
                    </div>
                    <div>
                      <div class="titleTxt">{{item.title}}</div>
                      <div class="contentDesc">{{item.desc}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="leftover" :style="{height:leftoverHeight+'px'}"></div>
          <div class="down" @click="swipeTo(2)">
            <img src="../assets/welcome/down.gif" alt="">
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="page">
          <div class="titleImg">
            <img src="../assets/welcome/yzxglbbdx.png" alt />
          </div>
          <div class="tagBox">
            <img src="../assets/welcome/advantage_ic0.png" alt />
          </div>
          <div class="content3">
              <div class="contentBox">
                  <div class="contentList" v-for="item in page3Content" :key="item.num">
                      <div class="listTop">
                          <span class="listNum">{{item.num}}</span>
                          <span class="listTitle">{{item.title}}</span>
                      </div>
                      <div class="listContent">
                          {{item.desc}}
                      </div>
                  </div>
              </div>
          </div>
          <div class="leftover" :style="{height:leftoverHeight+'px'}"></div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";
export default {
  data() {
    return {
      bodyHeight: 0,
      bodyWidth: 0,
      page1Content: [
        {
          num: 1,
          title: "全新机器",
          desc: "全新机器，正品保障,给您更好的体验",
          icon: require("../assets/welcome/ic_advantage_1.png")
        },
        {
          num: 2,
          title: "顺丰包邮",
          desc: "当天发货,超快物流,更快更省心",
          icon: require("../assets/welcome/ic_advantage_2.png")
        },
        {
          num: 3,
          title: "价格优惠",
          desc: "价格优惠，日租金低至9.9元/天",
          icon: require("../assets/welcome/ic_advantage_3.png")
        },
        {
          num: 4,
          title: "意外保障",
          desc: "购买放心飞服务，放心航拍，不怕摔",
          icon: require("../assets/welcome/ic_advantage_4.png")
        }
      ],
      page2Content: [
        {
          num: 1,
          title: "挑选商品",
          desc: "挑选您心仪的租赁商品,选择对应租期租赁",
          icon: require("../assets/welcome/process_ic1.png")
        },
        {
          num: 2,
          title: "认证免押",
          desc: "实名认证,认证通过即可减免押金",
          icon: require("../assets/welcome/process_ic2.png")
        },
        {
          num: 3,
          title: "顺丰包邮",
          desc: "顺丰包邮,在途不计算租期,签收次日开始计算租期",
          icon: require("../assets/welcome/process_ic3.png")
        },
        {
          num: 4,
          title: "收货体验",
          desc: "租期结束,归还商品,还可选择续租",
          icon: require("../assets/welcome/process_ic4.png")
        }
      ],
      page3Content: [
        {
          num: '01',
          title: "我从来没玩过无人机怎么办？",
          desc: "打开小程序，我们在学院中为您提供了专门的教程，只需几分钟小也能快速上手"
        },
        {
          num: '02',
          title: "我害怕机器损坏要赔偿？",
          desc: '我们提供专门的“保障服务"---放心飞，机器损坏由平台买单，打消您的怕摔担忧'
        },
        {
          num: '03',
          title: "怎么计算租赁时间?",
          desc: "在途期间不会计算租金，以您的实际签收时间为准，确保您每一分租金都没浪费"
        },
      ],
      leftoverHeight:0
    };
  },
  methods:{
    swipeTo(index){
      this.$refs.swiper.swipeTo(index)
    }
  },
  mounted() {
    const bodyWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    const bodyHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
    this.bodyHeight = bodyHeight;
    console.log(this.bodyHeight)
    let width =750;
    let height =1334;
    let bgImgHeight =bodyWidth/(750/1334);//背景图实际占用的高度 单位px
    this.leftoverHeight =bodyHeight- bgImgHeight>0?bodyHeight- bgImgHeight:0;//可视区域剩余的空白高度 单位px
  }
};
</script>

<style scoped lang='scss'>
@import "../common/font/font.css";
.welcomeBox {
  width: 100%;
  .my-swipe {
    height: 100vh;
  }
  .page {
    width: 100%;
    height: 100vh;
    background: url("../assets/welcome/advantage_bg.png") no-repeat;
    background-size: 100%;
    overflow: hidden;
    padding-top: 22px;
    box-sizing: border-box;
    position: relative;
    .leftover{
        width: 100%;
        background: url('../assets/welcome/bg_more.png') repeat-y;
        background-size: 100%;
        position: absolute;
        left: 0;
        bottom: 1px;
    }
    .down{
      position: absolute;
      bottom: 5px;
      z-index: 2;
      left: 50%;
      transform: translateX(-50%);
      img{
        width: 20px;
        height: 20px;
      }
    }
    .titleImg {
      width: 100%;
      padding: 0 22px;
      box-sizing: border-box;
      img {
        width: 100%;
      }
    }
    .tagBox {
      width: 100%;
      padding: 0 58px;
      box-sizing: border-box;
      margin-top: 9px;
      img {
        width: 100%;
      }
    }
    .content {
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      margin-top: 20px;
      .contentBox {
        width: 100%;
        background-color: #ffffff;
        padding: 32px 24px 22px 24px;
        box-sizing: border-box;
        border-radius: 5px;
        .contentTitle {
          width: 119px;
          margin: 0 auto;
          text-align: center;
          margin-bottom: 20px;
          img {
            width: 100%;
          }
        }
        .contentList {
          width: 100%;
          margin-bottom: 20px;
          .contentIcon {
            max-width: 69px;
            min-width: 69px;
            height: 69px;
            margin-right: 14px;
            img {
              width: 100%;
            }
          }
          .contentInfo {
            .title {
              margin-bottom: 6px;
              .titleNum {
                width: 14px;
                height: 14px;
                line-height: 14px;
                text-align: center;
                background: rgba(26, 95, 253, 1);
                border-radius: 50%;
                display: inline-block;
                font-size: 12px;
                font-weight: bold;
                color: rgba(255, 255, 255, 1);
              }
              .titleTxt {
                font-size: 15px;
                font-weight: bold;
                color: rgba(26, 95, 253, 1);
              }
            }
            .contentDesc {
              font-size: 13px;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
            }
          }
        }
        .contentList:last-child {
          margin-bottom: 0;
        }
      }
      .contentBox2 {
        width: 100%;
        padding: 11px 12px;
        box-sizing: border-box;
        background-color: #ffffff;
        border-radius: 5px;
        .contentTitle {
          width: 119px;
          margin: 0 auto;
          text-align: center;
          margin-bottom: 20px;
          img {
            width: 100%;
          }
        }
        .contentList {
          width: 100%;
          .contentIcon {
            max-width: 100px;
            min-width: 100px;
            height: 100px;
            margin-right: 20px;
            img {
              width: 100%;
            }
          }
          .contentInfo {
            display: flex;
            .title {
              margin-bottom: 6px;
              .titleNum {
                width: 16px;
                height: 16px;
                line-height: 16px;
                text-align: center;
                background: rgba(24, 127, 246, 1);
                border-radius: 0px 8px 8px 8px;
                display: inline-block;
                font-size: 12px;
                font-weight: bold;
                color: rgba(255, 255, 255, 1);
                margin-right: 7px;
              }
            }
            .titleTxt {
              font-size: 15px;
              font-weight: bold;
              color: rgba(26, 95, 253, 1);
              margin-bottom: 11px;
            }
            .contentDesc {
              font-size: 13px;
              font-weight: 400;
              color: #333333;
            }
          }
        }
        .contentIcon:nth-child(odd) {
          .contentIcon {
            margin-right: 0;
          }
        }
        .contentIcon:nth-child(even) {
          .contentIcon {
            margin-left: 20px;
          }
        }
        .contentList:last-child {
          margin-bottom: 0;
        }
      }
    }
    .content3{
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      margin-top: 20px;
      .contentBox {
        width: 100%;
        background-color: #ffffff;
        padding: 32px 25px;
        box-sizing: border-box;
        border-radius: 5px;
        .contentList{
            width: 100%;
            margin-bottom: 30px;
            
            .listTop{
                width: 100%;
                margin-bottom: 15px;
                .listNum{
                    font-size:20px;
                    font-family:'number';
                    font-weight:400;
                    color:rgba(26,95,253,1);
                }
                .listTitle{
                    font-size:15px;
                    font-weight:800;
                    color:rgba(26,95,253,1);
                }
            }
            .listContent{
                font-size:13px;
                font-family:PingFang SC;
                line-height:18px;
                color: #ffffff;
                height: 70px;
                background: url('../assets/welcome/question_bg.png') no-repeat;
                background-size: 100%;
                padding: 15px 12px;
                box-sizing: border-box;
            }
        }
        .contentList:last-child{
            margin-bottom: 0;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/welcome.vue